import { usePunditUserContext } from "@/react/contexts/punditUserContext";

import { isCommunityAdmin } from "../helpers/communityMemberHelpers";

export const useIsConnectEnabled = () => {
  const { currentCommunity, currentCommunityMember, currentCommunitySettings } =
    usePunditUserContext();

  if (!currentCommunityMember) return false;

  const isConnectEnabled = Boolean(currentCommunity?.connect_enabled);
  const isConnectAdminOnly = Boolean(
    currentCommunitySettings?.connect_admin_only,
  );
  const isAdmin = isCommunityAdmin(currentCommunityMember);

  if (isConnectAdminOnly) {
    return isAdmin && isConnectEnabled;
  }

  return isConnectEnabled;
};

export const useCanCreateConnection = () => {
  const { currentCommunityMember } = usePunditUserContext();

  if (!currentCommunityMember) return false;

  return currentCommunityMember.policies?.can_create_connection;
};

export const useIsConnectRecommendationsEnabled = () => {
  const { currentCommunity } = usePunditUserContext();

  return Boolean(currentCommunity?.connect_recommendations_enabled);
};
